import { useCallback } from "react";
import { getColumnKey, getColumnPos, renderColumnTitle } from "antd/es/table/util";
import cx from "classnames";
import { useCallbackRef } from "../../hooks";
import { FilterFilled } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function useFilter(_ref) {
  let {
    filters,
    disabled,
    onFilter
  } = _ref;
  const onFilterCallback = useCallbackRef(onFilter);
  const transformColumns = useCallback(cols => injectFilter(cols, filters, disabled, onFilterCallback), [filters, disabled]);
  return [transformColumns];
}
function injectFilter(columns, filters, disabled, onFilter, pos) {
  return columns.map((column, index) => {
    const columnPos = getColumnPos(index, pos);
    let newColumn = column;
    if (newColumn.filter) {
      const columnKey = getColumnKey(newColumn, columnPos);
      const active = !!filters?.find(el => el.dataIndex === columnKey);
      newColumn = {
        ...newColumn,
        title: renderProps => /*#__PURE__*/_jsx(TableFilterColumn, {
          active: active,
          disabled: disabled,
          onFilter: () => onFilter?.(columnKey),
          children: renderColumnTitle(column.title, renderProps)
        })
      };
    }
    if ("children" in newColumn) {
      newColumn = {
        ...newColumn,
        children: injectFilter(newColumn.children, filters, disabled, onFilter, columnPos)
      };
    }
    return newColumn;
  });
}
function TableFilterColumn(_ref2) {
  let {
    active,
    disabled,
    onFilter,
    children
  } = _ref2;
  const onClick = event => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) {
      onFilter?.();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "ant-table-filter-column",
    children: [/*#__PURE__*/_jsx("span", {
      className: "ant-table-column-title",
      children: children
    }), /*#__PURE__*/_jsx("span", {
      role: "button",
      tabIndex: -1,
      className: cx("ant-table-filter-trigger", {
        active,
        disabled
      }),
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FilterFilled, {})
    })]
  });
}
export default TableFilterColumn;